import * as React from "react";
import global from "../../../styles/global.module.scss";

export const NotFoundPage: React.FC = () => {
  return <div className={global.pageWrapper}>NotFound</div>;
};
